import { HotjarConfig } from '@habity/types';

// Track if Hotjar has been initialized
let isInitialized = false;

export const useHotjar = () => {
  const init = (config: HotjarConfig) => {
    // Only run in browser environment
    if (typeof window === 'undefined') return;
    
    // Prevent multiple initializations
    if (isInitialized) return;
    
    try {
      const { hjid, hjsv } = config;
      
      if (!hjid || !hjsv) {
        console.error('Hotjar configuration is missing required parameters');
        return;
      }
      
      // Create and add the Hotjar script
      const script = document.createElement('script');
      script.innerHTML = `
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${hjid},hjsv:${hjsv}};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `;
      document.head.appendChild(script);
      
      isInitialized = true;
    } catch (error) {
      console.error('Error initializing Hotjar:', error);
    }
  };
  
  return {
    init,
  };
};
